<div class="multi-select" (keydown.esc)="onEscapeKey()" (click)="checkMobile()">
    <div class="select">
        <button
            #selectButton
            class="select-button"
            aria-haspopup="listbox"
            aria-label="select a location"
            (click)="open = !open">
            <span class="text">
                <finder-font-icon [name]="icon" size="s" *ngIf="icon"></finder-font-icon>
                {{multiSelect.optionSelected}}
            </span>
            <finder-font-icon class="open-icon" name="norgie-opened"></finder-font-icon>
        </button>
    </div>
    <ul [hidden]="!open" *ngIf="!isMobile" class="list" role="listbox" id="multi-select-list" tabindex="-1">
        <li class="option"
            id="all"
            role="option">
            @defer {
                <finder-ra-checkbox
                    (keydownEvent)="onSelectAll($event)"
                    (clickEvent)="onClickAll($event)"
                    [checked]="multiSelect.allOption.checked"
                    (checkedChanged)="onCheckAll($event)">
                    {{multiSelect.allOption.value}}
                </finder-ra-checkbox>
            }
        </li>
        <li class="group">
            <ul>
                <li *ngFor="let option of multiSelect.options"
                    class="option"
                    [id]="option.key"
                    role="option">
                    @defer {
                        <finder-ra-checkbox
                            alignment="top"
                            [disabled]="disableOptions ? '' : null"
                            [checked]="option.checked"
                            (checkedChanged)="onCheck($event, option)">
                            {{option.value}}
                        </finder-ra-checkbox>
                    }
                </li>
            </ul>
        </li>
    </ul>
</div>
